<template>
    <nav id="navbar">
        <div class="navbar-left">
         
         
          <div class="link-home2">
  <div class="link-inner2" @click="toggleSidebar">
   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#fbbf24" d="M3 6a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m1.25 6a.75.75 0 0 1 .75-.75h15.19l-1.22-1.22a.75.75 0 1 1 1.06-1.06l2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5a.75.75 0 1 1-1.06-1.06l1.22-1.22H5a.75.75 0 0 1-.75-.75M4 17a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2z"/></svg>
  </div>
</div>

           
<router-link to="/" class="link-logo-mobile">
    <img :src="logoMiniUrl" alt="mini-logo" />
</router-link>

            <router-link to="/" class="link-logo">
    <img :src="logoUrl" alt="logo" />
</router-link>
           

<div class="navbar-tabs" v-if="!isMobile">
  <router-link
    to="/"
    class="tab"
    :class="{ active: $route.path === '/' || $route.path === '/tab1' }"
  >
    <img
      :src="$route.path === '/' || $route.path === '/tab1' ? require('@/assets/img/header/tab1-active.svg') : require('@/assets/img/header/tab1.svg')"
      alt="tab1"
      class="tab-icon"
    />
    {{ $t("navbar.tab1") }}
  </router-link>

  
  <router-link
    to="/futures"
    class="tab"
    :class="{ active: $route.path === '/futures' }"
  >
    <img
      :src="$route.path === '/futures' ? require('@/assets/img/header/tab3-active.svg') : require('@/assets/img/header/tab3.svg')"
      alt="tab3"
      class="tab-icon"
    />
    {{ $t("navbar.tab3") }}
  </router-link>
</div>


 

 
              
        </div>

        

<NavbarCashier v-if="authUser.user !== null" />
       <div class="navbar-right">
  <!-- Giriş yapmamışsa login/register butonu -->
  <AuthButton v-if="authUser.user === null" />

  <!-- Giriş yaptıysa kullanıcıya özel alanlar -->
  <div v-else class="right-auth">
    <NavbarUserDropdown />

    <div @click="openNotificationModal" class="notification-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path fill="#fbbf24" d="M13.714 20.82h-4.4a.245.245 0 0 0-.235.216a3 3 0 0 0 0 .274c0 1.886 2.041 3.065 3.675 2.122a2.45 2.45 0 0 0 1.225-2.122a3 3 0 0 0 0-.274a.245.245 0 0 0-.265-.216m.735-15.68a4.3 4.3 0 0 1 .343-1.695a6.2 6.2 0 0 0-1.813-.618V1.71a1.47 1.47 0 1 0-2.94 0v1.127a6.6 6.6 0 0 0-2.793 1.254a9 9 0 0 0-3.283 7.105v.745c0 2.5-.588 4.963-1.715 7.193a.5.5 0 0 0 .225.657a.5.5 0 0 0 .216.049h17.64a.49.49 0 0 0 .441-.706a16 16 0 0 1-1.715-7.193v-.745a9.4 9.4 0 0 0-.137-1.656h-.059a4.4 4.4 0 0 1-4.41-4.4"/>
        <path fill="#fbbf24" d="M15.919 5.14c0 2.263 2.45 3.678 4.41 2.546a2.94 2.94 0 0 0 1.47-2.546c0-2.263-2.45-3.678-4.41-2.546a2.94 2.94 0 0 0-1.47 2.546"/>
      </svg>
    </div>

    <div class="chat-icon" @click="handleChatButtonClick">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path fill="#fbbf24" d="M22 5a3 3 0 1 1-6 0a3 3 0 0 1 6 0"/>
        <path fill="#fbbf24" fill-rule="evenodd" d="M6.25 14a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75" clip-rule="evenodd"/>
        <path fill="#fbbf24" fill-rule="evenodd" d="M3.464 20.536C4.93 22 7.286 22 12 22s7.071 0 8.535-1.465C22 19.072 22 16.714 22 12c0-1.399 0-2.59-.038-3.612a4.5 4.5 0 0 1-6.35-6.35C14.59 2 13.399 2 12 2C7.286 2 4.929 2 3.464 3.464C2 4.93 2 7.286 2 12s0 7.071 1.464 8.535M6.25 17.5a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75" clip-rule="evenodd"/>
      </svg>
    </div>
  </div>

  <!-- DİL SEÇİMİ: her durumda gözükecek -->
  <div class="language-icon" @click="openLanguageModal">
    <img src="@/assets/img/sidebar/lang.svg" alt="Language" />
  </div>
</div>


   

 

     
      <LanguageModal 
  :show="showLanguageModal" 
  @close="showLanguageModal = false" 
/>
       
    </nav>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex';
    import IconChatGradient from '@/components/icons/IconChatGradient';
    import IconNavbarGradient from '@/components/icons/IconNavbarGradient';
    import IconHome from '@/components/icons/IconHome';
    import IconUser from '@/components/icons/IconUser';
    import IconVault from '@/components/icons/IconVault';
    import IconRakeback from '@/components/icons/IconRakeback';
    import IconAffiliates from '@/components/icons/IconAffiliates';
    import IconLeaderboard from '@/components/icons/IconLeaderboard';
    import IconSignOut from '@/components/icons/IconSignOut';
    import IconCrash from '@/components/icons/IconCrash';
    import IconBlackjack from '@/components/icons/IconBlackjack';
    import IconRoll from '@/components/icons/IconRoll';
    import IconDuels from '@/components/icons/IconDuels';
    import AuthButton from '@/components/AuthButton';
    import NavbarHomeDropdown from '@/components/navbar/NavbarHomeDropdown';
    import NavbarCashier from '@/components/navbar/NavbarCashier';
    import NavbarUserDropdown from '@/components/navbar/NavbarUserDropdown';
    
    import LanguageModal from "@/components/modals/LanguageModal.vue";
    
    import { ref } from "vue"
import { useRouter } from "vue-router"
    import axios from 'axios';
import { notification } from 'uikit';

    const activeTab = ref("tab1")
const router = useRouter()
function goTo(tab, path) {
  activeTab.value = tab
  router.push(path)
}
    export default {
        name: 'Navbar',
        components: {
            IconChatGradient,
            IconNavbarGradient,
            IconHome,
            IconUser,
            IconVault,
            IconRakeback,
            IconAffiliates,
            IconLeaderboard,
            IconSignOut,
            IconCrash,
            IconBlackjack,
            IconRoll,
            IconDuels,
            AuthButton,
            NavbarHomeDropdown,
            NavbarCashier,
            NavbarUserDropdown,
           LanguageModal,
          
        },
        data() {
    return {
       
      notifications: [],
      loading: false,
      errorMessage: '',
      isRotated: false, // SVG'nin döndüğünü izleyen durum
      showLanguageDropdown: false,
      showLanguageModal: false,
      logoUrl: null,
    logoMiniUrl: null,
            currentLanguage: this.$i18n.locale,
           languageOptions: {
    en: require('@/assets/img/flags/united-states-of-america.svg'),
    tr: require('@/assets/img/flags/tr.png'),
    de: require('@/assets/img/flags/germany.svg'),
    pt: require('@/assets/img/flags/brasil.svg'),
    fr: require('@/assets/img/flags/france.svg'),
    it: require('@/assets/img/flags/italy.png'),
    zh: require('@/assets/img/flags/china.svg'),
    hi: require('@/assets/img/flags/hint.png'),
    ru: require('@/assets/img/flags/russia.png'),
    id: require('@/assets/img/flags/id.webp'),
    es: require('@/assets/img/flags/spain.svg'),
}

    };
  },

async created() {
  // DİL AYARI
  const savedLanguage = localStorage.getItem('language')
  if (savedLanguage) {
    this.currentLanguage = savedLanguage
    this.$i18n.locale = savedLanguage
  }

  const backend = process.env.VUE_APP_BACKEND_URL.replace(/\/$/, "")

  try {
    // LOGO (DESKTOP)
    const resLogo = await axios.get(`${backend}/settings/logo`)
    if (resLogo.data?.logo) {
      this.logoUrl = backend + resLogo.data.logo
    } else {
      this.logoUrl = require("@/assets/img/logo.gif")
    }

    // MINI LOGO (MOBILE)
    const resMini = await axios.get(`${backend}/settings/logo-mini`)
    if (resMini.data?.logoMini) {
      this.logoMiniUrl = backend + resMini.data.logoMini
    } else {
      this.logoMiniUrl = require("@/assets/img/logomini.gif")
    }

  } catch (err) {
    console.error("Logo fetch failed:", err)
    // FALLBACK
    this.logoUrl = require("@/assets/img/logo.gif")
    this.logoMiniUrl = require("@/assets/img/logomini.gif")
  }
},


  mounted() {
  window.addEventListener('resize', this.handleResize);
},
        methods: {
          ...mapActions(["modalsSetShow"]),
  openNotificationModal() {
    this.modalsSetShow("Notifications");  // Vuex'teki modalsShow = "Notifications"
  },
          handleResize() {
    this.$forceUpdate(); // isMobile yeniden hesaplansın
  },
          toggleRotation() {
      this.isRotated = !this.isRotated; // Döndürme durumunu değiştir
    },
    toggleSidebar() {
      // Mevcut toggleSidebar işlevi
      console.log("Sidebar toggled");
    },
          toggleLanguageDropdown() {
        this.showLanguageDropdown = !this.showLanguageDropdown;
    },
    changeLanguage(lang) {
        this.currentLanguage = lang;
        this.$i18n.locale = lang;
        localStorage.setItem('language', lang); // Yeni dili kaydedin
        this.showLanguageDropdown = false;
    },
     openLanguageModal() {
      this.showLanguageModal = true;
    },
     
    handleChatButtonClick() {
        // Chat butonuna tıklandığında aynı işlevi uygular
        this.generalSetSidebarMobile('Chat'); // Sidebar'ı "Chat" modu ile açar
        
    },
            toggleNotificationsModal() {
      this.showNotificationsModal = !this.showNotificationsModal;
      if (this.showNotificationsModal) {
        this.fetchNotifications(); // Modal açıldığında bildirimleri getir
      }
    },
    async fetchNotifications() {
      this.loading = true;
      this.errorMessage = '';
      try {
        const response = await axios.get(`notices/${this.authUser.user._id}`);
        this.notifications = response.data;
      } catch (error) {
        console.error('Error fetching notifications:', error);
        this.errorMessage = 'Bildirimler yüklenirken bir hata oluştu.';
      } finally {
        this.loading = false;
      }
    },
    formatDate(date) {
      return new Date(date).toLocaleString();
    },
            ...mapActions([
        'notificationShow', 
        'modalsSetShow', 
        'generalSetSidebarMobile', 
        'authLogoutUser',
        'toggleSidebar' // Sidebar açma/kapama fonksiyonunu Vuex'ten alıyoruz
    ]),
            navbarVaultButton() {
                this.modalsSetShow('Vault');
                this.generalSetSidebarMobile(null);
            }
        },
        beforeDestroy() {
  window.removeEventListener('resize', this.handleResize);
},
 
        computed: {
           currentLanguageIcon() {
      const lang = this.$i18n.locale; // aktif dil
      try {
        return require(`@/assets/img/flags/${lang}.svg`);
      } catch {
        return require("@/assets/img/flags/en.svg");
      }
    },
        isMobile() {
    return window.innerWidth <= 1175;
  },
          currentLanguageIcon() {
            return this.languageOptions[this.currentLanguage];
        },
            ...mapGetters([
                'generalSidebarMobile', 
                'authUser'
            ])
        }
    }
</script>

<style scoped>
    nav#navbar {
        width: 100%;
        height: 60px;
        position: fixed;
        display: flex;
        justify-content: space-between;
        align-items: center;
        top: 0;
        left: 0;
        
        background: var(--navbar-bg);
   
        z-index: 50;
    }

    nav#navbar .navbar-left,
    nav#navbar .navbar-right  {
        
        display: flex;
        align-items: center;
        z-index: 1;
    }

    nav#navbar .navbar-right  {
        justify-content: flex-end;
    }

  

    nav#navbar .navbar-left a.link-logo {
        display: flex;
        align-items: center;
        margin-right: 30px;
    }

    nav#navbar .navbar-left a.link-logo img {
        height: 41px;
        width: 100%;
    }

    nav#navbar .navbar-left a.link-home {
        width: 50px;
        height: 50px;
        position: relative;
        margin-right: 10px;
        padding: 1px;
        z-index: 1;
    }

    nav#navbar .navbar-left a.link-home::before {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: linear-gradient(180deg, rgba(0, 133, 255, 0) 0%, #328adb 100%);
        clip-path: polygon(8px 0, calc(100% - 8px) 0, 100% 25%, 100% 75%, calc(100% - 8px) 100%, 8px 100%, 0 75%, 0 25%);
        z-index: -1;
    }

    nav#navbar .navbar-left a.link-home::after {
        content: '';
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        position: absolute;
        top: 1px;
        left: 1px;
        background: #061628;
        clip-path: polygon(8px 0, calc(100% - 8px) 0, 100% 25%, 100% 75%, calc(100% - 8px) 100%, 8px 100%, 0 75%, 0 25%);
        z-index: -1;
    }

    nav#navbar .navbar-left a.link-home .link-inner {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: linear-gradient(255deg, rgba(59, 126, 183, 0.5) -70%, rgba(20, 80, 129, 0.5) 90%);
        clip-path: polygon(8px 0, calc(100% - 8px) 0, 100% 25%, 100% 75%, calc(100% - 8px) 100%, 8px 100%, 0 75%, 0 25%);
        transition: background 0.3s ease;
    } 

    nav#navbar .navbar-left a.link-home:hover .link-inner {
        background: linear-gradient(255deg, #3b7eb7 -70%, #145081 90%);
    }

    nav#navbar .navbar-left a.link-home .link-inner svg {
        fill: #6e95b6;
        transition: fill 0.3s ease;
    }

    nav#navbar .navbar-left a.link-home:hover .link-inner svg {
        fill: #ffffff;
    }

    nav#navbar .navbar-mid button.auth-button {
        display: none;
    }

     nav#navbar .navbar-mid {
        display: none;
    }
    nav#navbar .right-auth {
        display: flex;
        align-items: center;
    }

    nav#navbar a.link-rewards {
         
        height: 40px;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
        margin-left: 25px;
        padding: 0 15px 0 50px;
        border-radius: 5px;
        background: var(--button);
    }

    nav#navbar a.link-rewards img {
        height: 41px;
        position: absolute;
        top: 50%;
        left: -15px;
        transform: translate(0, -50%);
        filter: drop-shadow(0px 0px 4px rgba(7, 211, 143, 0.35));
    }

    nav#navbar a.link-rewards span {
    font-family: 'Rubik', sans-serif;
    font-size: 14px;
    font-weight: 900;
    text-transform: uppercase; /* daha güçlü görünüm için */
    
    /* Gradient yazı */
    background: linear-gradient(180deg, 
        #ffffff 0%, 
        #ffffff 35%, 
        #7e7e7e 70%, 
        #18d99d 95%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;

    /* Stroke + Glow */
    -webkit-text-stroke: 0.8px rgba(0, 0, 0, 0.5);
    text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.45),
                 0px 0px 10px rgba(253, 253, 253, 0.6);

    letter-spacing: 0.5px;
    display: inline-block;
}


    nav#navbar .navbar-right button.button-toggle {
        width: 36px;
        height: 28px;
        display: none;
        filter: drop-shadow(0px 1.8px 1.8px rgba(0, 0, 0, 0.10));
    }

    nav#navbar .navbar-right button.button-toggle .button-inner {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #214059;
        clip-path: polygon(4px 0, calc(100% - 4px) 0, 100% 25%, 100% 75%, calc(100% - 4px) 100%, 4px 100%, 0 75%, 0 25%);
    }

    nav#navbar .navbar-right button.button-toggle .button-inner svg {
        fill: #5b7b95;
        transition: fill 0.3s ease;
    }

    nav#navbar .navbar-right button.button-toggle:hover .button-inner svg {
        fill: #ffffff;
    }

    nav#navbar .navbar-mobile {
    width: 60vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    transform: translateX(-100%); /* Başlangıçta gizli */
    padding: 95px 21px 0 21px;
    overflow-y: scroll;
    background-color: #021423;
    z-index: 999; /* En üstte görüntülenmesi için */
    transition: transform 0.3s ease;
}

    nav#navbar .navbar-mobile a,
    nav#navbar .navbar-mobile button {
        width: 100%;
        position: relative;
        display: flex;
        align-items: center;
        padding-bottom: 8px;
        font-size: 16px;
        font-weight: 600;
        color: #bbbfd0;
        border-bottom: 1px solid #102b3f;
    }

    nav#navbar .navbar-mobile .mobile-user a,
    nav#navbar .navbar-mobile .mobile-games a,
    nav#navbar .navbar-mobile .mobile-user button {
        margin-top: 25px;
    }

    nav#navbar .navbar-mobile a.router-link-exact-active,
    nav#navbar .navbar-mobile a.link-blackjack.router-link-active {
        background: linear-gradient(250deg, #01e0a3 0%, #00aa6d 100%), #a6cae8;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
    }

    nav#navbar .navbar-mobile a::before,
    nav#navbar .navbar-mobile button::before {
        width: 100%;
        height: 1px;
        position: absolute;
        bottom: 0;
        left: 0;
        background-color: #102b3f;
    }

    nav#navbar .navbar-mobile a svg,
    nav#navbar .navbar-mobile button svg {
        width: 13px;
        margin-right: 8px;
        fill: #bbbfd0;
    }

    nav#navbar .navbar-mobile a.router-link-exact-active svg,
    nav#navbar .navbar-mobile a.link-blackjack.router-link-active svg {
        fill: #01e0a3;
    }

    nav#navbar .mobile-games {
        margin-top: 36px;
        font-size: 16px;
        font-weight: 800;
        color: #ffffff;
    }


    .navbar-tabs {
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--background1); /* senin gradientini de koyabilirsin */
  border-radius: 10px;
  padding: 4px;
  margin-left: 15px;
}

.navbar-tabs .tab {
  font-family: "Rubik", sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: var(--text-color);
  text-decoration: none;
  padding: 8px 14px;
  border-radius: 8px;
  transition: all 0.25s ease;
  gap: 6px;
  display: flex;
  align-items: center;
}

.tab-icon {
  width: 24px;
  height: 24px;
}

.navbar-tabs .tab:hover {
  background: rgba(255, 255, 255, 0.1);
}

.navbar-tabs .tab.active {
      background: var(--buttonpurple);
    box-shadow: var(--buttonpurplebox);
  color: #fff;
  text-shadow: 0px 0px 4px #C56A18;
  border-radius: 12px;
  
}

@media (max-width: 1024px) {
  .navbar-tabs {
    display: none !important;
  }
}

    @media only screen and (max-width: 1750px) {

        nav#navbar {
            
        }

    }

    @media only screen and (max-width: 1650px) {

        nav#navbar .left-rakeback,
        nav#navbar .right-links {
            display: none;
        }
       

    }



    @media only screen and (max-width: 1500px) {

        nav#navbar {
            width: 100%;
        }

    }

    @media only screen and (max-width: 1175px) {

       

        nav#navbar .navbar-left, 
        nav#navbar .navbar-right {
            width: auto;
        }

        nav#navbar .navbar-left button.button-chat,
        nav#navbar .navbar-right button.button-toggle {
            display: none;
        }
        
       
        nav#navbar .navbar-right button.auth-button,
        nav#navbar .right-auth {
            display: flex;
        }

        nav#navbar a.link-rewards,
        nav#navbar .navbar-left a.link-logo,
        nav#navbar .navbar-left a.link-home,
        nav#navbar .navbar-left .navbar-home-dropdown
        nav#navbar .navbar-right .notification-icon
         {
            display: none;
        }

        nav#navbar .navbar-mid button.auth-button {
            display: block;
        }

        nav#navbar .navbar-mobile.mobile-open {
            transform: translate(0, 0);
        }

    }
  

.category-path {
    fill: #6e95b6; /* Varsayılan renk */
    transition: fill 0.3s ease;
  }

  .category-button:hover .category-path {
    fill: #ffffff; /* Hover olduğunda renk */
  }

  .link-home2 {
    width: 50px;
    height: 50px;
    position: relative;
    
    padding: 1px;
    z-index: 1;
    top: 0;
    left: 0;
    content: '';
  }
  .link-inner2 {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: background 0.3s ease;
  }
  .modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 35px 30px 30px 30px;
    border-radius: 15px;
    background: radial-gradient(100% 100% at 50% 0%, rgba(0, 255, 194, 0.15) 0%, rgba(7, 38, 61, 0) 80%), linear-gradient(256deg, #07263d 0%, #07243a 100%);
    width: 400px;
}

.notification-icon {
  width: 40px;
    height: 40px;
    cursor: pointer;
    display: flex;
    margin-right: 10px;
    align-items: center;
    justify-content: center;
    background: var(--background2);
    
    border-radius: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-right: 5px;
    padding-left: 5px;
    position: relative;
    z-index: 1;
        margin-left: 10px;
}



.notification-icon img {
  width: 24px;
  height: 24px;
}

.close-button {
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #6c757d;
  transition: color 0.3s ease;
}

.close-button:hover {
  color: #000000;
}

h2 {
  margin-top: 0;
  font-size: 24px;
  background: linear-gradient(250deg, #01e0a3 0%, #00aa6d 100%), #a6cae8;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.notification-list {
  list-style: none;
  padding: 0;
  margin-top: 20px;
}

.notification-item {
  background-color: #1a4f63;
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 15px;
  transition: background-color 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  width: 300px;
}

.notification-item:hover {
  background-color: #1a4f63;
}

.notification-item h3 {
  margin: 0;
  font-size: 18px;
  color: #bbbfd0;
}

.notification-item p {
  margin: 5px 0;
  font-size: 14px;
  color: #bbbfd0;
}

.notification-date {
  font-size: 12px;
  color: #888;
}

.loading-message,
.error-message,
.no-notifications {
  font-size: 16px;
  color: #555;
  text-align: center;
}

@media only screen and (max-width: 1175px) {
    .notification-icon {
        display: none; /* Username ve level tamamen gizlenir */
    }
    

}



.language-icon {
  width: 40px;
    height: 40px;
    cursor: pointer;
    margin-left: 5px;
    display: flex;
    margin-right: 10px;
    align-items: center;
    justify-content: center;
    background: var(--background2);
    
    border-radius: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-right: 5px;
    padding-left: 5px;
    position: relative;
    z-index: 1;
  
}

 
.language-icon img {
    width: 24px;
    height: 24px;
    border-radius: 50%; /* Bayrakları yuvarlak yapmak için */
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

 
.bonus-time {
  display: flex;
  align-items: center;
  background: radial-gradient(164.23% 68.81% at 100% 100%, #4afece80 0, #4afee91c 72.4%, #fe4a4a00),
              radial-gradient(203.92% 89.64% at 9.37% -19.79%, #4afeca80 0, #4afee91c 72.4%, #fe8b4a00),
              #253532;
  border-radius: 8px;
  padding: 5px 10px;
  margin-left: 10px;
  height: 36px;
}

.bonus-time img {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}

.bonus-time span {
  color: white;
  font-weight: 700;
  font-size: 14px;
}

/* Mobil versiyon */
.bonus-time-mobile {
      background: var(--background2);
  
  width: 40px;
  height: 40px;
  border-radius: 10px;
  margin-left: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
}

.bonus-time-mobile img {
  width: 24px;
  height: 24px;
}
.language-dropdown {
    position: absolute;
    top: 60px;
    right: 0;
    width: 150px;
    background: #0c2a44;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    z-index: 1000;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    transition: all 0.3s ease;
}

.language-option {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
}

.language-option:hover {
    background-color: #1a4f63;
    transform: scale(1.05); /* Hover'da hafif büyütme efekti */
}

.language-option img {
    width: 24px;
    height: 24px;
    margin-right: 10px;
    border-radius: 50%;
    transition: transform 0.3s ease;
}

.language-option img:hover {
    transform: rotate(10deg); /* Hover'da küçük bir dönüş efekti */
}

.language-option span {
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
}

.language-dropdown::before {
    content: '';
    position: absolute;
    top: -10px;
    right: 20px;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #0c2a44; /* Dropdown okunun rengi */
}

.chat-icon {
    width: 40px;
    height: 40px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--background2);
    
    border-radius: 10px;
    margin-right: 5px;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-right: 5px;
    padding-left: 5px;
    position: relative;
    z-index: 1;
}


 
.chat-icon img {
    width: 24px;
    height: 24px;
}

.chat-icon.has-notification::after {
    display: block; /* Bildirim varsa göster */
}

@media only screen and (max-width: 768px) {
    .chat-icon {
        display: none; /* Mobil cihazlarda Chat butonunu gizler */
    }
    .language-icon {
        display: none; /* Mobil cihazlarda Chat butonunu gizler */
    }
    .link-inner2 {
   display: none;
  }
  .link-home2 {
   width: 20px;
  }
    
}
svg {
  transition: transform 0.3s ease;
}

svg.rotated {
  transform: rotate(180deg);
}

.link-logo-mobile {
  display: none; /* Varsayılan olarak gizle */
}

@media only screen and (max-width: 768px) {
  .link-logo-mobile {
    display: block; /* Mobil cihazlarda görünür yap */
    width: 36px; /* Genişlik 50px */
    height: 36px; /* Yükseklik 50px */
    margin: 0 auto; /* Ortalamak için */
    text-align: center;
  }

  .link-logo-mobile img {
    width: 36px; /* Resim genişliği */
    height: 36px; /* Resim yüksekliği */
   
  }
}


</style>

